
import { base_environment } from "./environment.base";
import { custom_environment } from "../app/custom/environment.prod";

/** core environment used to extend by custom*/
const core_environment = {
  /** System runs in production mode */
  production: true,
};

/** Properties of the environment */
export const environment = { ...base_environment, ...core_environment, ...custom_environment };

/** Alias for environment */
export const env = environment;
